import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App as AntApp, ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import enGB from 'antd/locale/en_GB';
import { App } from './App';
import { theme } from './theme';
import './styles.css';
if (process.env.NODE_ENV === 'development') {
    // The dev server's overlay shows a promise rejected with a plain object as "[object Object]" and no stack. This
    // adds a second overlay entry under it with the object's contents, so the cause can be found. (Crypto-wallet
    // extension errors are stopped earlier, in public/index.html.)
    window.addEventListener('unhandledrejection', (event) => {
        if (event.reason instanceof Error)
            return;
        let detail;
        try {
            detail = JSON.stringify(event.reason, null, 2);
        }
        catch {
            detail = String(event.reason);
        }
        console.error('Unhandled promise rejection with a non-Error value:', event.reason);
        const error = new Error(`Unhandled promise rejection (not an Error): ${detail}`);
        if (typeof window.reportError === 'function')
            window.reportError(error);
        else
            setTimeout(() => { throw error; });
    });
}
createRoot(document.getElementById('root')).render(<StrictMode>
    <ConfigProvider theme={theme} locale={enGB}>
      <AntApp>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  </StrictMode>);
